import React, { useEffect, useState } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DropDownList, MultiSelect, TagData } from '@progress/kendo-react-dropdowns';
import { UserApi } from '../../../redux/api/UserApi';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { IStaff } from '../../../types/IStaff';
import { ITeam } from '../../../types/ITeam';
import { Button } from '@progress/kendo-react-buttons';
import { ErrorBoundary } from '../../Common/ErrorBoundry';
import { filterBy } from '@progress/kendo-data-query';
import StaffList from '../../User/ListControls/StaffList';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { Label } from '@progress/kendo-react-labels';
import { useCurrentUserContext } from '../../../context/UserContext';
const ActionAuthor: React.FC<FieldRenderProps> = props => {
    const {
        values,
        companyId,
        onChange,
        id,
        valid,
        label,
        showAddButton,
    } = props;

    const { profile: userProfile } = useCurrentUserContext();
    const [team, setTeam] = useState<ITeam>();
    const { data: allStaff } = UserApi.useGetStaffQuery({ teamId: undefined, includeQueues: false, includeStaffPlusForCompanyId: companyId || 0 });
    //const { data: staffMembers } = UserApi.useGetStaffQuery({ teamId: team?.ID, includeQueues: false, includeStaffPlusForCompanyId: companyId || 0 });
    const [selectedStaff, setSelectedStaff] = useState<IStaff[]>([]);
    const [opened, setOpened] = useState(false);
    const { data: teams } = UserApi.useGetTeamsQuery()
    const handleSelectionChange = (event: any) => {
        setSelectedStaff(event.target.value);

    };
    const currentValues = values?.length > 0 ? allStaff?.filter(i => values?.indexOf(i.ID) > -1) : undefined;
    const handleConfirm = () => {
        onChange({ value: selectedStaff?.length ? selectedStaff.map(s => s.ID) : null });

        setOpened(false);
    };

    useEffect(() => {
        if (team?.ID && allStaff) {
            setSelectedStaff(allStaff.filter((staff: IStaff) => staff.Team_Name === team.Dept_Name || !team?.ID));
        }


    }, [team]);

    const parent = React.useRef<HTMLDivElement>(null);
    const [filteredStaff, setFilteredStaff] = React.useState<IStaff[]>();
    const filterChange = (event) => {
        setFilteredStaff(filterBy(allStaff.slice(), event.filter));

        console.log('filterChange', event.filter);
    };
    useEffect(() => {
        if (!filteredStaff && allStaff) {
            setFilteredStaff(allStaff.filter((staff: IStaff) => staff.Team_Name === team?.Dept_Name || !team));
        }
    }, [allStaff]);

    //reset the selected staff when the dialog is opened
    useEffect(() => {
        if (opened) {
            setSelectedStaff(currentValues ?? []);
        }
    }
        , [opened]);

    return (<div ref={parent}>
        {/* <div>currentValues:{JSON.stringify(currentValues)} - {JSON.stringify(values)}  - {allStaff?.length}</div> */}
        {currentValues?.length > 1 ? <>
            <Label
                editorId={id}
                editorValid={valid} >
                {label}
            </Label>
            <MultiSelect popupSettings={{ className: "z500" }} placeholder='Select' onOpen={() => setOpened(true)} value={currentValues} data={allStaff} textField="Full_Name" dataItemKey='ID'
                opened={false}
                onChange={() => { setOpened(true) }}
                //onBlur={() => { setOpened(false) }}
                tags={currentValues?.length > 1 ? [{ text: `${currentValues?.length} staff selected`, data: [...currentValues] } as TagData] : currentValues?.length === 1 ? [{ text: currentValues[0].Full_Name, data: [...currentValues] } as TagData] : []}
            /> </>
            : <StaffList {...props} addClicked={() => setOpened(true)} />}
        {opened &&
            <Dialog className='cool-window-nope' modal={false} onClose={() => setOpened(false)} title="Select multiple Authors" width={400} height={300}>
                <div>
                    <label>{userProfile?.Phrases.Team}</label>
                    <DropDownList defaultItem={{ Dept_Name: "Select a team to add all staff as authors" }}
                        data={teams} // Assuming `teams` is an array of team objects with `id` and `name` properties
                        textField="Dept_Name" // Adjust this to match your team object structure
                        dataItemKey="ID"
                        value={team}
                        onChange={(event) => {
                            setTeam(event.target.value); // Set the selected team
                        }}
                    />
                </div>
                <div>
                    <label>Author/s</label>
                    <ErrorBoundary>
                        <MultiSelect
                            data={filteredStaff?.filter((staff: IStaff) => staff.Team_Name === team?.Dept_Name || !team?.ID) ?? []}
                            textField="Full_Name"
                            dataItemKey="ID"
                            value={selectedStaff}
                            onChange={handleSelectionChange}
                            placeholder="Select staff members..."
                            onFilterChange={filterChange}
                            filterable={true}
                        />
                    </ErrorBoundary>
                </div>
                <DialogActionsBar>
                    <Button fillMode='outline' onClick={() => setOpened(false)}>
                        Cancel
                    </Button>
                    <Button disabled={!selectedStaff?.length} fillMode='outline' onClick={handleConfirm} style={{ backgroundColor: userProfile?.Nav_Hex_Color, color: '#fff' }} >
                        Confirm
                    </Button>
                </DialogActionsBar>
            </Dialog>}</div>
    )
};

export default ActionAuthor;